import { Table } from '@radix-ui/themes'
import styled from 'styled-components'

export const StyledTableRoot = styled(Table.Root)`
  width: 100%;
  .rt-ScrollAreaViewport {
    overflow: visible !important;
  }
  .rt-ScrollAreaRoot {
    overflow: visible !important;
  }
`

export const HeaderRow = styled(Table.Row)`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.forecast.cardGroupBackground};
  color: ${({ theme }) => theme.forecast.secondaryText};
`

export const ColumnHeaderCell = styled(Table.ColumnHeaderCell)`
  display: flex;
  box-shadow: none;
  width: 100%;
  padding: 0.5rem;
  font-weight: 500;
`

export const ActionColumnHeaderCell = styled(ColumnHeaderCell)`
  width: 5rem;
`

export const StyledRow = styled(Table.Row)`
  display: flex;
  color: ${({ theme }) => theme.forecast.defaultText};
  border-bottom: solid 1px
    ${({ theme }) => theme.forecast.cardDividerBackground};
`

export const StyledCell = styled(Table.Cell)`
  display: flex;
  width: 100%;
  padding: 0.625rem 0.5rem;
  box-shadow: none;
`

export const StyledActionCell = styled(StyledCell)`
  width: 5rem;
`
